<div
  [class]="
    'fixed md:relative z-20 transform transition-all duration-300 ease-in-out ' +
    (isMobileMenuOpen
      ? 'translate-x-0'
      : '-translate-x-full md:translate-x-0') +
    ' flex flex-col bg-light-surface dark:bg-dark-surface h-screen flex-shrink-0 border-r border-light-border dark:border-dark-border ' +
    (isSidebarCollapsed ? 'md:w-20   w-72' : 'w-72 md:w-80')
  "
  (click)="$event.stopPropagation()"
  >
  <!-- Logo with expandable button -->
  <div
    class="sidebar-header-fixed-height flex flex-col items-center p-4 border-b border-light-border-light dark:border-dark-border relative"
    >
    <!-- Mobile Menu Toggle -->
    <button
      (click)="toggleMobileMenu.emit()"
      class="md:hidden absolute left-4 top-4 p-1.5 rounded-lg hover:bg-light-bg-secondary dark:hover:bg-dark-surface-variant"
      >
      <lucide-angular
        [img]="isMobileMenuOpen ? X : Menu"
        class="w-5 h-5"
      ></lucide-angular>
    </button>

    <!-- Desktop: Copec logo, hidden when collapsed -->
    <app-brand-logo [class.hidden]="isSidebarCollapsedEffective"></app-brand-logo>
    @if (isSidebarCollapsedEffective) {
      <img src="assets/logo_icon.png" alt="Logo AI" class="h-10 mt-2 ml-1" />
    }

    <!-- Desktop Collapse Toggle Button -->
    <button
      (click)="toggleSidebar()"
      class="hidden md:flex absolute right-0 top-1/2 transform translate-x-1/2 -translate-y-1/2 p-1.5 rounded-full bg-light-surface dark:bg-dark-surface border border-light-border dark:border-dark-border hover:bg-light-bg-secondary dark:hover:bg-dark-surface-variant transition-colors z-50 shadow-md"
      >
      <lucide-angular
        [img]="ChevronLeft"
        [class]="'w-4 h-4 transition-transform duration-300 ' + (isSidebarCollapsedEffective ? 'rotate-180' : '')"
        [matTooltip]="isSidebarCollapsedEffective ? 'Expandir barra lateral' : 'Colapsar barra lateral'"
        [matTooltipPosition]="'right'"
        [matTooltipShowDelay]="500"
        [matTooltipHideDelay]="200"
      ></lucide-angular>
    </button>
  </div>

  <!-- Navigation -->
  <nav class="flex-1 px-4 py-4 space-y-1 overflow-hidden">
    <!-- Public Navigation Items (always visible) -->
    @for (item of publicNavigationItems; track item.id) {
      <div
        [class]="'nav-item px-3.5 py-3' + (isRouteActive(item.id) ? ' active' : '')"
        (click)="onNavigate(item.id)"
        [matTooltip]="isSidebarCollapsedEffective ? item.label : ''"
        [matTooltipPosition]="'right'"
        [matTooltipShowDelay]="300"
        [matTooltipHideDelay]="200"
        >
        <lucide-angular [img]="item.icon" class="w-5 h-5 flex-shrink-0"></lucide-angular>
        <span class="sidebar-label text-sm transition-all duration-300" [class]="'transition-all duration-300 ' + (isSidebarCollapsedEffective ? 'hidden' : '')">{{ item.label }}</span>
      </div>
    }

    <!-- Separator between public and RBAC items -->
    @if (rbacNavigationItems.length > 0) {
      <div class="my-3 border-t border-light-border-light dark:border-dark-border"></div>
    }

    <!-- RBAC Navigation Items (filtered by roles) -->
    @for (item of rbacNavigationItems; track item.id) {
      @if (item.children) {
        <!-- Parent item with children (collapsable) -->
        <div
          [ngClass]="(item.isExpanded && isSidebarCollapsedEffective ? 'outline outline-2 outline-light-border-light dark:outline-dark-border rounded-xl pb-1.5' : '')">
          <div
            [class]="'flex items-center gap-3 px-3.5 py-3 hover:bg-light-bg-tertiary dark:hover:bg-dark-surface-variant transition-all duration-200 cursor-pointer'
              + (isSidebarCollapsedEffective && item.isExpanded
              ? ' bg-light-bg-tertiary dark:bg-dark-surface-variant rounded-t-xl'
              : ' rounded-xl')"
            (click)="toggleSubMenu(item)"
            [matTooltip]="isSidebarCollapsedEffective ? item.label : ''"
            [matTooltipPosition]="'right'"
            [matTooltipShowDelay]="300"
            [matTooltipHideDelay]="200"
            >
            <lucide-angular [img]="item.icon" class="w-5 h-5 flex-shrink-0"></lucide-angular>
            <span class="sidebar-label text-sm flex-1 transition-all duration-300" [class]="'transition-all duration-300 ' + (isSidebarCollapsedEffective ? 'hidden' : '')">{{ item.label }}</span>
            @if (!isSidebarCollapsedEffective) {
              <lucide-angular
                [img]="item.isExpanded ? ChevronDown : ChevronRight"
                class="w-4 h-4"
              ></lucide-angular>
            }
          </div>

          <!-- Subitems -->
          @if (item.isExpanded) {
            <div [class]="'mt-1 space-y-1' + (isSidebarCollapsedEffective ? ' ml-0' : ' ml-4')">
              @for (child of item.children; track child.id) {
                <div
                  [class]="'nav-item text-sm'"
                  [ngClass]="{
                    'active': isRouteActive(child.id),
                    'px-3.5 py-3': !isSidebarCollapsedEffective,
                    'md:justify-center md:m-1.5 md:py-2 md:rounded-[11px]': isSidebarCollapsedEffective
                  }"
                  (click)="onNavigate(child.id)"
                  [matTooltip]="isSidebarCollapsedEffective ? child.label : ''"
                  [matTooltipPosition]="'right'"
                  [matTooltipShowDelay]="300"
                  [matTooltipHideDelay]="200"
                  >
                  <lucide-angular [img]="child.icon" class="w-5 h-5 flex-shrink-0"></lucide-angular>
                  <span class="sidebar-label text-sm flex-1 transition-all duration-300" [class]="'transition-all duration-300 ' + (isSidebarCollapsedEffective ? 'hidden' : '')">{{ child.label }}</span>
                </div>
              }
            </div>
          }
        </div>
      } @else {
        <!-- Regular item without children -->
        <div
          [class]="'nav-item px-3.5 py-3' + (isRouteActive(item.id) ? ' active' : '')"
          (click)="onNavigate(item.id)"
          [matTooltip]="isSidebarCollapsedEffective ? item.label : ''"
          [matTooltipPosition]="'right'"
          [matTooltipShowDelay]="300"
          [matTooltipHideDelay]="200"
          >
          <lucide-angular [img]="item.icon" class="w-5 h-5 flex-shrink-0"></lucide-angular>
          <span class="sidebar-label text-sm transition-all duration-300" [class]="'transition-all duration-300 ' + (isSidebarCollapsedEffective ? 'hidden' : '')">{{ item.label }}</span>
        </div>
      }
    }
  </nav>

  <!-- User Profile Section with Dropup Menu -->
  <div class="relative sidebar-footer-fixed-height">
    <!-- Dropup Menu - Modo Expandido -->
    @if (isUserMenuOpen && !isSidebarCollapsedEffective) {
      <app-button-display
        [items]="expandedMenuItems"
        [isCompact]="false"
      ></app-button-display>
    }

    <!-- Dropup Menu - Modo Colapsado -->
    @if (isUserMenuOpen && isSidebarCollapsedEffective) {
      <app-button-display
        [items]="compactMenuItems"
        [isCompact]="true"
        containerClass="user-dropup-menu compact"
        iconClass="w-5 h-5"
      ></app-button-display>
    }

    <!-- Footer Trigger -->
    <div
      class="user-footer-trigger"
      [class.active]="isUserMenuOpen"
      (click)="toggleUserMenu()"
      [style.cursor]="'pointer'"
      [matTooltip]="isSidebarCollapsedEffective ? 'Ver más' : ''"
      [matTooltipPosition]="'right'"
      [matTooltipShowDelay]="300"
      [matTooltipHideDelay]="200"
      >
      @if (!isSidebarCollapsedEffective) {
        <!-- Expanded view -->
        <div class="flex items-center flex-1 min-w-0">
          <div
            class="w-9 h-9 rounded-full flex items-center justify-center font-medium text-sm flex-shrink-0"
            [ngStyle]="{
              'background-color': isDarkTheme
                ? 'rgba(138, 180, 248, 0.2)'
                : 'rgba(26, 115, 232, 0.1)',
              color: isDarkTheme ? '#8ab4f8' : '#1a73e8',
            }"
            >
            {{ user?.name?.charAt(0) || "U" }}
          </div>
          <div class="flex-1 min-w-0 mx-3">
            <p class="text-sm font-medium text-light-text dark:text-dark-text truncate !m-0">
              {{ getUserFullName() || "Usuario" }}
            </p>
            <div class="flex items-center mt-0.5">
              <app-environment-indicator></app-environment-indicator>
            </div>
          </div>
          <lucide-angular
            [img]="EllipsisVertical"
            class="w-4 h-4 text-light-text-tertiary dark:text-dark-text-tertiary transition-transform duration-200 flex-shrink-0"
          ></lucide-angular>
        </div>
      } @else {
        <!-- Collapsed view: only user icon -->
        <div class="flex flex-col items-center gap-3 w-full pt-1">
          <div
            class="w-9 h-9 rounded-full flex items-center justify-center font-medium text-sm"
            [ngStyle]="{
              'background-color': isDarkTheme
                ? 'rgba(138, 180, 248, 0.2)'
                : 'rgba(26, 115, 232, 0.1)',
              color: isDarkTheme ? '#8ab4f8' : '#1a73e8',
            }"
            >
            {{ user?.name?.charAt(0) || "U" }}
          </div>
        </div>
      }
    </div>
  </div>
</div>
